import { AstraHeading, AstraParagraph } from '~/astra'
import { useMultiQuery } from '~/hooks/tanstack-query'
import { importPractitionerStatusDefinitions } from '~/store/di-entity.api'
import { importStatusDefinitionDepartmentAssignments } from '~/store/di-entity.api.generated'
import { usePractitionerStatusDefinitions } from '~/storm'
import { groupStatusDefinitionsByAssignment } from '~/utils/surgeryActivities'

import { StatusesSkeleton } from './StatusesSkeleton'
import { StatusGroup } from './StatusGroup'
import { StatusItem } from './StatusItem'

export const Statuses = () => {
    const { isLoading } = useMultiQuery([
        { queryFn: () => importStatusDefinitionDepartmentAssignments({}), queryKey: ['statusDefinitionDepartmentAssignments'] },
        { queryFn: () => importPractitionerStatusDefinitions({}), queryKey: ['practitionerStatusDefinitions'] },
    ])

    const allStatusDefinitions = usePractitionerStatusDefinitions()
    const statusGroups = groupStatusDefinitionsByAssignment(allStatusDefinitions)

    return (
        <div className="flex h-full w-full overflow-hidden bg-surface-base">
            <div className="mx-auto flex h-full min-h-0 w-full max-w-[780px] flex-col gap-4 px-4 py-10">
                <div className="flex flex-col gap-2">
                    <AstraHeading as="h2">Aktivitet</AstraHeading>
                    <AstraParagraph className="text-default">Aktivitetsstatuser definerer hva slags aktivitet kirurgen er planlagt til å gjøre.</AstraParagraph>
                </div>

                <div className="min-h-0 flex-1 rounded-lg border border-base bg-surface-base px-2 py-4">
                    {isLoading ? (
                        <StatusesSkeleton />
                    ) : (
                        <div className="flex h-full min-h-0 flex-col gap-4 overflow-auto">
                            {statusGroups.map(group => (
                                <StatusGroup key={group.assignment} title={group.title} assignment={group.assignment}>
                                    {group.statusCodes.map(code => (
                                        <StatusItem key={code} code={code} />
                                    ))}
                                </StatusGroup>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
